// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"1191f8b2","93":"8d20fd7b","282":"f9454fd1","379":"08d6621f","464":"02aabfeb","646":"e66a68f5","730":"fd08e2bd","780":"4dfb31d6","810":"f53e7ecd","819":"069b669b","930":"279c5de9","965":"ff4ddf37","970":"9a1fa6c1"}[chunkId] + ".chunk.js";
};